import React from "react";
import styled from "styled-components";
import FAQSection from "./components/FAQSection";
import ContactSection from "../contact/components/ContactSection";

const Wrapper = styled.div``;

function FaqPage() {
  return (
    <Wrapper>
      <FAQSection />
    </Wrapper>
  );
}

export default FaqPage;
